import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const method = config.method?.toLowerCase();
  if (["put", "patch", "delete"].includes(method) && typeof window !== "undefined") {
    const label = method === "delete" ? "supprimer" : method === "put" ? "modifier" : "mettre à jour";
    if (!window.confirm(`Confirmer l’action : ${label} ?`)) {
      return Promise.reject(new axios.Cancel("Action annulée"));
    }
  }
  return config;
});

export const getError = (error) => {
  const detail = error.response?.data?.detail;
  if (Array.isArray(detail)) return detail.map((item) => item.msg || "Donnée invalide").join(" · ");
  return detail || "Une erreur est survenue. Réessayez.";
};

export default api;